import { render, staticRenderFns } from "./ActivityHistory.vue?vue&type=template&id=08b1564e&scoped=true&"
import script from "./ActivityHistory.vue?vue&type=script&lang=js&"
export * from "./ActivityHistory.vue?vue&type=script&lang=js&"
import style0 from "./ActivityHistory.vue?vue&type=style&index=0&id=08b1564e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b1564e",
  null
  
)

export default component.exports